import Cookies from 'js-cookie';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';

// Context
import { ContentProcessContext } from '../../../context/ContentProcessContext.jsx';
import { HeaderContext } from '../../../context/HeaderContext.jsx';

// Constants && Utils
import i18n from '../../../i18n/es.json';
import { parseCSS } from '../../../utils/common';

// Components
import UserMenu from '../../userMenu/UserMenu.jsx';

// Styles
import classes from './HeaderCommon.module.css';

const HeaderCommon = ({ pageName }) => {
  const auth = Cookies.get('auth') && JSON.parse(Cookies.get('auth'));
  const location = useLocation();

  // States
  const [userLogged, setUserLogged] = useState();
  const [hasAnonymPermission, setHasAnonymPermission] = useState(true);
  const [shouldShowPageName, setShouldShowPageName] = useState(true);

  // Context
  const { subtitleStyle, title, subTitle } = useContext(HeaderContext);
  const { anonymProcesses } = useContext(ContentProcessContext);

  // Styles
  const objStyle = subtitleStyle ? parseCSS(subtitleStyle) : {};

  // ------------------------------------------- //
  // -------------- Action Handlers ------------ //
  // ------------------------------------------- //

  const setUser = () => {
    if (auth) {
      const user = {
        username: auth.username,
        profileName: auth.profileName,
      };
      setUserLogged(user);
    }
  };

  // ------------------------------------------- //
  // ---------- Side Effects Handlers ---------- //
  // ------------------------------------------- //

  useEffect(() => {
    setUser();
  }, []);

  useEffect(() => {
    if (location.pathname.includes('createAnonymProcess')) {
      const processDescriptor = location.pathname.split('/').pop();
      const anonymProcess = anonymProcesses.get(processDescriptor);
      const hasPermission = !!anonymProcess?.id;
      setHasAnonymPermission(hasPermission);
      setShouldShowPageName(hasPermission);
    } else {
      setShouldShowPageName(true);
    }
  }, [location, anonymProcesses]);

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <>
      <header className={classes.header}>
        <div className={classes.titleSectionContainer}>
          {process.env.REACT_APP_ENVIROMENT_QA === 'true' && location.pathname.includes('createAnonymProcess') ? (
            <div className={classes.cartelambienteprueba} style={{ display: hasAnonymPermission ? 'block' : 'none' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                </svg>
                <p className={classes.textAlerta}>
                  {i18n.ambiente.prueba} {i18n.ambiente.produccion}
                </p>
              </div>
            </div>
          ) : null}{' '}
          <div className={classes.pageTitleContainer}>
            {shouldShowPageName && <p className={classes.pageSection}>{pageName}</p>}
            {title && (
              <>
                <span className={classes.arrowRight}>
                  <i className="bi bi-chevron-right" />
                </span>
                <p className={`${classes.pageTitle}`}>
                  {title}{' '}
                  <label className="subtitle" style={{ ...objStyle }}>
                    {subTitle}
                  </label>
                </p>
              </>
            )}
          </div>
        </div>
        {userLogged && <UserMenu userLogged={userLogged} />}
      </header>
    </>
  );
};

export default HeaderCommon;
